import Cookies from 'js-cookie'
import { setAccessToken, setRefreshHandler } from '@/config/api/authStore'
import { refreshAccessToken } from '@/services/auth/authApi'
import { useAuthSessionStore } from '@/store/authSessionStore'

export function applyAuthSessionTokens(user, token, refreshToken, loginType) {
  useAuthSessionStore.getState().setSession({
    user: {
      ...user,
      user_id: user?.user_id || user?.id || '',
      email: user?.email || '',
      first_name: user?.first_name || user?.firstName || '',
      last_name: user?.last_name || user?.lastName || '',
    },
    accessToken: token,
    refreshToken,
    loginType,
  })

  setAccessToken(token)
  Cookies.set('authToken', token, { sameSite: 'lax' })

  if (!refreshToken) return

  let currentRefreshToken = refreshToken
  setRefreshHandler(async () => {
    const next = await refreshAccessToken(currentRefreshToken)
    if (!next?.access_token && !next?.token) return null
    const nextToken = next.access_token || next.token
    currentRefreshToken = next.refresh_token || currentRefreshToken
    useAuthSessionStore.getState().setSession({
      user: useAuthSessionStore.getState().user,
      accessToken: nextToken,
      refreshToken: currentRefreshToken,
      loginType,
    })
    Cookies.set('authToken', nextToken, { sameSite: 'lax' })
    return nextToken
  })
}
